/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateAdminUserDto } from '../../models/update-admin-user-dto';
import { UserResponseAdminAdminDto } from '../../models/user-response-admin-admin-dto';

export interface AdminUsersControllerUpdateAdminUser$Params {
  id: string;
      body: UpdateAdminUserDto
}

export function adminUsersControllerUpdateAdminUser(http: HttpClient, rootUrl: string, params: AdminUsersControllerUpdateAdminUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminUsersControllerUpdateAdminUser.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserResponseAdminAdminDto>;
    })
  );
}

adminUsersControllerUpdateAdminUser.PATH = '/admin/users/{id}';
